// extracted by mini-css-extract-plugin
module.exports = {"scrollFix":"image-module--scroll-fix--1RkGZ","imgContainer":"image-module--imgContainer--3e-Bg","img":"image-module--img--3Nv6X","caption":"image-module--caption--1PWfR"};